import CryptoJS from 'crypto-js'
const storage = window.localStorage
const key = CryptoJS.enc.Utf8.parse('7e^V9FLMatcyX0kA').toString()
const iv = CryptoJS.enc.Utf8.parse('kr6V%xV&tQj8kH13').toString()
/**
 * 单例模式 实现 LocalStorage
 * 保证实例对象的唯一性
 */            
export default class LocalStorage {

  public static instance: LocalStorage;

  private constructor () {}

  // 挂载到类上，而不是实例上 
  static getInstance(){
    if(!this.instance){
      this.instance =new LocalStorage();
    }
    return this.instance
  }

  public set(name: string, value: any): void {
    if (typeof value === 'object') {
      value = JSON.stringify(value)
    } else {
      value = JSON.stringify({ myCacheValue: value })
    }
    // Triple DES 加密
    const encrypted = CryptoJS.TripleDES.encrypt(value.toString(), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString()
    storage.setItem(name, encrypted)
  }

  public get(name: string): any {
    const temp = storage.getItem(name)
    if (temp === null) {
      return null
    }
    // Triple DES 解密
    let decrypted = CryptoJS.TripleDES.decrypt(temp, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    // 转换为 utf8 字符串
    decrypted = CryptoJS.enc.Utf8.stringify(decrypted) || temp
    const obj = JSON.parse(decrypted)
    if (obj.myCacheValue) {
      return obj.myCacheValue
    }
    return obj
  }

  public clear(name: string): void {
    if (name) {
      storage.removeItem(name)
    } else {
      storage.clear()
    }
  }
}
export const localStorage = LocalStorage.getInstance()